export const getImageVariant = (product, productIdColourList) => {
  const img = product.images.find((item) => {
    return productIdColourList[product.id] === item.colour;
  });
  return (img && img.colour) || "";
};
